export function formatDealCount(count) {
  const n = count ?? 0;
  if (n === 1) return '1 deal';
  return `${n} deals`;
}

export function closedStageTagLabel(stage) {
  if (stage?.is_won) return 'Closed Won';
  if (stage?.is_lost) return 'Closed Lost';
  return null;
}
